import React from "react";
import { observer, useLocalObservable } from "mobx-react-lite";
import MainContainer from "../components/containers/MainContainer";
import TopBar from "../components/containers/TopBar";
import ChooseBetPlace from "../components/ChooseBetPlace";
import classnames from "classnames";
import t, { t2 } from "../Locale";
import { sort } from "../utils/functions";
import {
	Badge,
	Button,
	Card,
	Container,
	Dialog,
	DialogActions,
	DialogContent,
	DialogContentText,
	DialogTitle,
	Fab,
	FormControl,
	Grid,
	InputLabel,
	makeStyles,
	Typography,
	Zoom,
} from "@material-ui/core";
import Global from "../assets/css/style";

import SwapHorizIcon from "@material-ui/icons/SwapHoriz";
import DeleteIcon from "@material-ui/icons/Delete";
import ListAltIcon from "@material-ui/icons/ListAlt";
import { useDispatch, useSelector } from "react-redux";
import BottomFloat2 from "../components/containers/BottomFloat2";
import { toJS } from "mobx";
import Timer2 from "../components/Timer2";
import { setTotoPlaceBet } from "../redux/items/TotoPlaceBet";
import { appendPlaceBetFinal } from "../redux/items/TotoPlaceBetFinal";
import TotoDrawNo from "../components/TotoDrawNo";
import { useHistory } from "react-router";
import LastSecondToto from "../components/LastSecondToto";
import v2 from "../assets/constants";
import FetchNoLogin from "../components/Fetch/FetchNoLogin";
import { useEffect } from "react";
import { setDialogLogin } from "../redux/items/DialogLogin";

const useStyles = makeStyles((theme) => ({
	label: {
		fontSize: 22,
		fontWeight: "bold",
		marginBottom: 6,
		marginTop: 8,
	},
	buttonGroupInner: {
		backgroundColor: "#fff",
	},
	static: {
		position: "static",
	},
	selectionsPad: {
		padding: "12px 24px",
	},
	card: {
		marginTop: 32,
		marginBottom: -24,

		border: "0.5px solid #C4C4C4",
		boxShadow: "0px 2px 8px rgba(0, 0, 0, 0.15)",
		borderRadius: 21,
	},
	selectionsBorderNoRight: {
		borderRight: 0,
	},
	button: {
		fontSize: 14,
	},
	contentDrawDate: {
		padding: 24,
	},
	fabWrapper: {
		position: "fixed",
		bottom: theme.spacing(1),
		maxWidth: theme.breakpoints.values.sm,
		width: "100%",
	},
	fab: {
		position: "absolute",
		bottom: theme.spacing(7),
		right: theme.spacing(3),
		backgroundColor: "green",
		color: "#fff",
		width: 88,
		height: 88,
		"& .MuiFab-label": {
			display: "flex",
			flexDirection: "column",
		},
	},
}));

const TotoPlace = observer(() => {
	const language = useSelector((state) => state.Language);
	const listBetType = useSelector((state) => state.drawSet?.TotoSet);
	const cache = useSelector((state) => state.drawSet.set?.image_cache);
	const TotoSet = useSelector((state) => state.drawSet?.TotoSet);
	const login = useSelector((state) => state.login);
	const enable_book_toto = useSelector(
		(state) => state.drawSet.set?.enable_book_toto
	);

	const v = useLocalObservable(() => ({
		selectedDraw: "",
		formPlaceBet: [],
		_: {
			isFirstRun: true,
		},
		listBetType: [...listBetType],
		listSelectableDraw: ["Current", "2 Draws", "4 Draws"],
		eachWidthSectableDraw() {
			return "calc(" + 100 / this.listSelectableDraw.length + "% - 1px)";
		},
		createTextField() {
			let tmpEachTextField = [];
			[...Array(this.selectedBetType?.no)].map(() => {
				tmpEachTextField.push("");
				return undefined;
			});
			this.formPlaceBet.push([...tmpEachTextField]);
		},
		removeTextField(index) {
			v.formPlaceBet.splice(index, 1);
		},
		clearAll() {
			this.formPlaceBet = [];
			this.createTextField();
		},
		randomNumber(min = 1, max = 49) {
			return Math.floor(Math.random() * (max - min + 1)) + min;
		},
		uniqueRandomNumber(index) {
			let tmpEachTextField = [];
			[...Array(this.selectedBetType.no)].map(() => {
				while (1) {
					let randomNumber = String(this.randomNumber());
					if (tmpEachTextField.indexOf(randomNumber) === -1) {
						tmpEachTextField.push(randomNumber);
						break;
					}
				}
				return undefined;
			});
			this.formPlaceBet[index] = tmpEachTextField;
		},
		addAndTrim(e) {
			let changeTo = JSON.parse(e);
			let tmpPlaceBet = [...this.formPlaceBet];
			if (tmpPlaceBet.length > 0) {
				while (1) {
					if (changeTo.no > tmpPlaceBet[0].length) {
						tmpPlaceBet.forEach((a, aI) => {
							tmpPlaceBet[aI].push("");
						});
					} else if (changeTo.no < tmpPlaceBet[0].length) {
						tmpPlaceBet.forEach((a, aI) => {
							tmpPlaceBet[aI].pop();
						});
					} else {
						break;
					}
				}
				this.formPlaceBet = tmpPlaceBet;
			} else {
				this.clearAll();
			}
			this.selectedBetType = changeTo;
		},
		amountCount() {
			let index = this.listSelectableDraw.indexOf(this.selectedDraw);
			let times = 1;
			if (index === 0) times = 1;
			else if (index === 1) times = 2;
			else times = 4;

			return this.formPlaceBet.length * this.selectedBetType?.price * times;
		},
		openModalChooseNumber: false,
		indexModalChooseNumber: -1,
		countNonSpace() {
			let nonSpace = 0;
			this.formPlaceBet[this.indexModalChooseNumber].forEach((e) => {
				if (e !== "") nonSpace++;
			});
			return nonSpace;
		},
		replaceSpaceToNumber(number) {
			if (this.countNonSpace() >= this.selectedBetType.no) {
				// do nothing
			} else {
				let index = this.formPlaceBet[this.indexModalChooseNumber].indexOf("");
				this.formPlaceBet[this.indexModalChooseNumber][index] = number;
			}
		},
		replaceNumberToSpace(number) {
			let index =
				this.formPlaceBet[this.indexModalChooseNumber].indexOf(number);
			this.formPlaceBet[this.indexModalChooseNumber][index] = "";
		},
		checkNumberSelected(number) {
			let numberSelected =
				this.indexModalChooseNumber !== -1
					? [...this.formPlaceBet[this.indexModalChooseNumber]]
					: [];
			if (numberSelected.indexOf(String(number)) > -1) {
				return true;
			}
			return false;
		},
		errors: "",
		changingBetTypeConfimation: "",
		changingBetType: false,
	}));
	const dispatch = useDispatch();
	const classes = useStyles();
	const totoPlaceBet = useSelector((state) => state.totoPlaceBet);
	const totoPlaceBetFinal = useSelector((state) => state.totoPlaceBetFinal);

	const hist = useHistory();

	if (v._.isFirstRun) {
		v._.isFirstRun = false;

		if (totoPlaceBet.selectedBetType !== undefined) {
			v.selectedBetType = totoPlaceBet.selectedBetType;
		} else {
			v.selectedBetType = v.listBetType[0];
		}

		if (totoPlaceBet.selectedDraw !== undefined) {
			v.selectedDraw = totoPlaceBet.selectedDraw;
		} else {
			if (v.selectedDraw === "") {
				v.selectedDraw = v.listSelectableDraw[0];
			}
		}

		if (totoPlaceBet.formPlaceBet !== undefined) {
			v.formPlaceBet = totoPlaceBet.formPlaceBet;
		} else {
			v.createTextField();
		}
	}

	let sorted = [];
	let raw = toJS(v.formPlaceBet);
	raw.forEach((a) => {
		sorted.push(sort(a));
	});
	if (JSON.stringify(v.formPlaceBet) !== JSON.stringify(sorted)) {
		v.formPlaceBet = sorted;
	}

	const convertArrStrtoArrNum = (arr) => {
		let tmpArr = [];
		arr.forEach((e) => {
			let tmpArr2 = [];
			e.forEach((e2) => {
				tmpArr2.push(Number(e2));
			});
			tmpArr.push({ eachPlaceBet: tmpArr2 });
		});
		return tmpArr;
	};

	React.useEffect(() => {
		let d = { ...toJS(v) };
		let d2 = {
			selectedDraw: d.selectedDraw,
			formPlaceBet: d.formPlaceBet,
			selectedBetType: d.selectedBetType,
		};
		dispatch(setTotoPlaceBet(d2));
		// eslint-disable-next-line
	}, [v.selectedDraw, v.formPlaceBet, v.formPlaceBet?.length]);

	React.useEffect(() => {
		if (v.changingBetTypeConfimation !== "") v.changingBetType = true;
		//eslint-disable-next-line
	}, [v.changingBetTypeConfimation]);

	const reqCheckToto = FetchNoLogin("check-toto", {
		data: {
			betType: v.selectedBetType?.name,
			drawWeeks: v.selectedDraw,
			placeBet: convertArrStrtoArrNum(v.formPlaceBet),
		},
		callbackInit: () => {
			v.errors = "";
		},
		callback: (cb) => {
			if (!cb.response.success) v.errors = cb.response.message;
			else {
				dispatch(
					appendPlaceBetFinal({
						betType: v.selectedBetType.name,
						drawWeeks: v.selectedDraw,
						placeBet: convertArrStrtoArrNum(v.formPlaceBet),
					})
				);
				v.formPlaceBet = [];
				v.createTextField();
			}
		},
	});

	// debugging;
	// useEffect(() => {
	//   dispatch(resetPlaceBetFinal());
	// }, []);

	useEffect(() => {
		if (enable_book_toto) {
			if (TotoSet === undefined) window.location.reload();
		}
		if (process.env.REACT_APP_YES_APP !== undefined) {
			if (login?.token === undefined) dispatch(setDialogLogin(true));
		}
		// eslint-disable-next-line
	}, []);

	return (
		<>
			<MainContainer
				render={
					<Grid container direction="column">
						<TopBar leftSide="-1" title={t("Toto")} rightSide="">
							<Grid item container>
								<Grid item xs={8} className={classes.contentDrawDate}>
									<Typography>
										<b>{t("Draw Date")}:</b>
										<br />
										<Timer2 />
									</Typography>
								</Grid>
								<Grid
									item
									xs={4}
									className={classnames(
										classes.contentDrawDate,
										classes.contentDrawDateRight
									)}
								>
									<Typography>
										<b>{t("Draw No.")}</b>
										<br />
										<TotoDrawNo />
									</Typography>
								</Grid>
							</Grid>
						</TopBar>
					</Grid>
				}
			>
				<div style={{ marginTop: -40, position: "relative" }}>
					<ChooseBetPlace select="toto" />
				</div>

				<LastSecondToto />

				{v.selectedBetType?.msg?.map((a, aI) => {
					if (a.type === "image")
						return (
							<img
								src={
									process.env.REACT_APP_BASE_IMAGE_URL +
									"/" +
									a.value +
									"?c=" +
									cache
								}
								key={aI}
								style={{ width: "100%" }}
								alt="News"
							/>
						);
					else return <div key={aI}>{a.value}</div>;
				})}

				<InputLabel className={classnames(classes.label)}>
					{t("Bet Type")}
				</InputLabel>
				<select
					className={classnames("styled-select")}
					value={JSON.stringify(v.selectedBetType)}
					onChange={(e) => {
						v.changingBetTypeConfimation = e.target.value;
					}}
				>
					{v.listBetType?.map((a, aI) => (
						<option value={JSON.stringify(a)} key={aI}>
							{t(a.name)}
						</option>
					))}
				</select>

				<form
					onChange={(e) => {
						v.selectedDraw = e.target.value;
					}}
					className="buttongroup radio"
				>
					{v.listSelectableDraw?.map((a, aI) => (
						<label
							className={classnames(classes.buttonGroupInner, "labelgroup")}
							style={{
								width: v.eachWidthSectableDraw(),
							}}
							key={aI}
						>
							<input
								type="radio"
								name="draw"
								value={a}
								checked={a === v.selectedDraw}
								onChange={() => {}}
							/>
							<span>{t(a)}</span>
						</label>
					))}
				</form>

				<FormControl>
					<InputLabel className={classnames(classes.static, classes.label)}>
						{t("Selections")}
					</InputLabel>
					<div className="wrapper-right">
						<span
							style={{
								color: Global.color,
								cursor: "pointer",
							}}
							onClick={() => v.clearAll()}
						>
							{t("Clear All")}
						</span>
					</div>
				</FormControl>

				<div style={{ marginBottom: 20 }}>
					{v.formPlaceBet.map((a, aI) => (
						<Card className={classes.card} key={aI} style={{ borderRadius: 5 }}>
							<Grid container direction="column">
								<Grid item container>
									<Grid item xs={3} className={classes.selectionsPad}>
										<SwapHorizIcon
											style={{
												color: Global.color,
												fontSize: 48,
												cursor: "pointer",
											}}
											onClick={() => {
												v.uniqueRandomNumber(aI);
											}}
										/>
									</Grid>
									<Grid
										item
										xs={6}
										className={classes.selectionsPad}
										style={{
											fontSize: 24,
											textAlign: "center",
											marginTop: 10,
										}}
									>
										{t2("Board", language)} {aI + 1}
									</Grid>
									<Grid
										item
										xs={3}
										className={classes.selectionsPad}
										style={{
											textAlign: "center",
										}}
									>
										{aI > -1 && (
											<DeleteIcon
												style={{
													color: Global.defaultColor,
													fontSize: 48,
													cursor: "pointer",
												}}
												onClick={() => v.removeTextField(aI)}
											/>
										)}
									</Grid>
								</Grid>
								<Grid item container className="container-numbers">
									{[...Array(v.selectedBetType?.no)].map((b, bI) => (
										<Grid
											item
											xs={v.selectedBetType?.columns}
											className={classnames(classes.selectionsBorder)}
											key={bI}
											style={{
												height: 60,
												position: "relative",
											}}
										>
											<span
												style={{
													display: "inline-block",
													width: "calc(100% - 1px)",
													border: "1px solid #ddd",
													height: "calc(100% - 1px)",
													textAlign: "center",
													lineHeight: 3.5,
													cursor: "pointer",
													position: "absolute",
												}}
												onClick={() => {
													v.indexModalChooseNumber = aI;
													v.openModalChooseNumber = true;
												}}
											>
												{v.formPlaceBet[aI][bI] === ""
													? "-"
													: v.formPlaceBet[aI][bI]}
											</span>
										</Grid>
									))}
									{v.selectedBetType?.r ? (
										<Grid
											item
											xs={2}
											className={classnames(classes.selectionsBorder)}
											key={5}
											style={{ height: 60 }}
										>
											<span
												style={{
													display: "inline-block",
													width: "100%",
													border: "1px solid #ddd",
													height: "100%",
													textAlign: "center",
													lineHeight: 3.5,
													cursor: "pointer",
													color: "#555",
												}}
												onClick={() => {
													v.indexModalChooseNumber = aI;
													v.openModalChooseNumber = true;
												}}
											>
												R
											</span>
										</Grid>
									) : null}
								</Grid>
							</Grid>
						</Card>
					))}

					<Button
						type="button"
						className={classes.button}
						onClick={() => {
							v.createTextField();
						}}
						style={{ marginTop: 32 }}
					>
						{t("Add Board")}
					</Button>
				</div>

				<Container className={classes.fabWrapper}>
					{totoPlaceBetFinal?.length > 0 && (
						<Zoom in className={classes.fab}>
							<Fab
								onClick={() => {
									hist.push("/personal-details-toto");
								}}
							>
								<Badge
									badgeContent={totoPlaceBetFinal.length}
									color="secondary"
								>
									<ListAltIcon />
								</Badge>
								Bet Slip
							</Fab>
						</Zoom>
					)}
				</Container>

				<Typography
					dangerouslySetInnerHTML={{ __html: v.errors }}
					style={{
						color: "red",
						textAlign: "center",
						paddingTop: 20,
						paddingBottom: 20,
					}}
				/>

				<BottomFloat2
					total={v.amountCount()}
					// onClick={async () => {
					//   v.errors = "";
					//   dispatch(setLoadingPage(true));
					//   let data = {
					//     betType: v.selectedBetType.name,
					//     drawWeeks: v.selectedDraw,
					//     placeBet: v.formPlaceBet,
					//   };
					//   let retCheck = await axiosReq("check-place-bet-toto", data);
					//   dispatch(setLoadingPage(false));
					//   if (retCheck.status === "error") {
					//     v.errors = retCheck.message;
					//   } else {
					//     let d = [...totoPlaceBetFinal, { ...data }];
					//     let { compute, total } = computationToto([...d]);
					//     dispatch(setPlaceBetFinal2([...compute]));
					//     dispatch(setTotoTotal(total));

					//     v.formPlaceBet = [];
					//     v.createTextField();
					//   }
					// }}
					onClick={() => reqCheckToto.handleTrigger()}
				/>
			</MainContainer>
			<Dialog
				open={v.openModalChooseNumber}
				className="dialog-choose-number"
				onClose={() => {
					v.indexModalChooseNumber = -1;
					v.openModalChooseNumber = false;
				}}
			>
				<DialogTitle
					style={{
						textAlign: "center",
						color: "#666",
						backgroundColor: "#ddd",
						fontSize: 48,
						position: "relative",
					}}
				>
					Select {v.selectedBetType?.no} Numbers
					<span
						style={{
							position: "absolute",
							left: 12,
							top: 16,
							color: v2.primary,
							cursor: "pointer",
						}}
						onClick={() => {
							v.indexModalChooseNumber = -1;
							v.openModalChooseNumber = false;
						}}
						className="noselect"
					>
						Close
					</span>
					<SwapHorizIcon
						style={{
							color: Global.color,
							fontSize: 48,
							cursor: "pointer",
							position: "absolute",
							right: 12,
							top: 8,
						}}
						onClick={() => {
							v.uniqueRandomNumber(v.indexModalChooseNumber);
						}}
					/>
				</DialogTitle>
				<DialogContent style={{ overflowY: "visible" }}>
					<Grid
						container
						style={{
							backgroundColor: "transparent",
							overflowY: "hidden",
						}}
						className="number-container"
					>
						{[...Array(49)].map((a, aI) => (
							<Grid
								item
								container
								key={aI}
								style={{
									width: "calc(" + 100 / 7 + "% - 0px)",
									height: 60,
								}}
							>
								<label>
									<input
										type="checkbox"
										value={aI + 1}
										onChange={(evt) => {
											if (evt.target.checked) {
												v.replaceSpaceToNumber(evt.target.value);
											} else {
												v.replaceNumberToSpace(evt.target.value);
											}
										}}
										checked={v.checkNumberSelected(aI + 1)}
									/>
									<span>{aI + 1}</span>
								</label>
							</Grid>
						))}
					</Grid>
				</DialogContent>
				<DialogActions>
					<Button
						onClick={() => {
							v.indexModalChooseNumber = -1;
							v.openModalChooseNumber = false;
						}}
					>
						Submit
					</Button>
				</DialogActions>
			</Dialog>
			<Dialog open={v.changingBetType}>
				<DialogContent>
					<DialogContentText>
						{t2("Changing bet types will clear all selections.", language)}
					</DialogContentText>
				</DialogContent>
				<DialogActions>
					<Button
						onClick={() => {
							v.addAndTrim(v.changingBetTypeConfimation);
							v.changingBetType = false;
						}}
					>
						Ok
					</Button>
					<Button
						onClick={() => {
							v.changingBetTypeConfimation = "";
							v.changingBetType = false;
						}}
					>
						Cancel
					</Button>
				</DialogActions>
			</Dialog>
		</>
	);
});

export default TotoPlace;
